<template>
    <div>
        <div class="col-md-4 col-sm-5 p-2 titleBlock">
            {{ title | decoder}}
        </div>    
        <div class="pt-3" id="text-head">
            <h2 v-html="$options.filters.decoder(subtitle)"></h2>
            <p v-html="$options.filters.decoder(text)"> </p>
        </div>  
    </div>  
</template>

<script>
export default {
    props:{
        title:{
            type: String,
        },
        subtitle:{
            type: String,
        },
        text:{
            type: String,
        }
    },
    filters:{
        decoder : function(value){
            if (!value) return ''
            return window.atob(value);
        }
    }
}
</script>

<style scoped>
    #text-head{
        border-top:2px solid gray;
    }
    #text-head p{
        font-size: 14px;
    }
</style>





// WEBPACK FOOTER //
// src/components/overall_layouts/bbnc-content.vue